<div class="top-tools-tab-mobile" id="tabs-tools" role="tablist">
    <a [routerLink]="['/grammar-checker']" role="tab" aria-selected="false" tabindex="-1" id="tab-grammar">
        <img src="assets/images/menu-icons/grammar-checker.svg" alt="文法 チェック">
        <p>文法チェッカー</p>
    </a>
    <a [routerLink]="['/paraphrasing-tool']" role="tab" aria-selected="false"  class="active" tabindex="-1" id="tab-paraphraser">
        <img src="assets/images/menu-icons/pharaphraser.svg" alt="言い換える">
        <p>パラフレーズツール</p>
    </a>
    <a [routerLink]="['/ai-content-detector']" role="tab" aria-selected="false" tabindex="-1" id="tab-ai-detector">
        <img src="assets/images/menu-icons/ai-detector.svg" alt="AI検出器">
        <p>AI生成コンテンツ検出ツール</p>
    </a>
</div>

<section class="banner-section" style="overflow: inherit;">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="toolLinkingTabs">
                        <!-- <ul>
                            <li>
                                <a [routerLink]="['/grammar-checker']" routerLinkActive="active">
                                    <img class="grammarCheckerIcons" src="assets/icons/GrammarChecker.svg" alt="">
                                    <img class="grammarCheckerActiveIcons" src="assets/icons/GrammarCheckerActive.svg" alt="">
                                    <span>Grammar checker</span>
                                </a>
                            </li>
                            <li>
                                <a  [routerLink]="['/paraphrasing-tool']" routerLinkActive="active">
                                    <img class="grammarCheckerIcons" src="assets/icons/ParaphrasingTool.svg" alt="">
                                    <img class="grammarCheckerActiveIcons" src="assets/icons/ParaphrasingToolActive.svg" alt="">
                                    <span>Paraphrasing tool</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/ai-content-detector']" routerLinkActive="active">
                                    <img class="grammarCheckerIcons" src="assets/icons/AIContentDetector.svg" alt="">
                                    <img class="grammarCheckerActiveIcons" src="assets/icons/AIContentDetectorActive.svg" alt="">
                                    <span>AI Content Detector</span>
                                </a>
                            </li>
                            <li>
                                <a [routerLink]="['/academic-phrasebank']" routerLinkActive="active">
                                    <img class="grammarCheckerIcons" src="assets/icons/AcademicPhraseBank.svg" alt="">
                                    <img class="grammarCheckerActiveIcons" src="assets/icons/AcademicPhraseBankActive.svg" alt="">
                                    <span>Academic PhraseBank</span>
                                </a>
                            </li>
                        </ul> -->
                    </div>
                    <h1><span>パラフレーズツール</span></h1>
                    <p>Trinkaパラフレーズツールでより明瞭な文章に。元の意味を保ちつつ、質の高い表現への言い換えやリフレーズが可能です。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card paraphraser-card">
                    <div class="card-header">
                        <h3 class="d-none d-md-block">文章をパラフレーズする</h3>
                        <div class="degreeChange">
                            <ul>
                                <li>
                                    <div class="slidecontainer">
                                        <span>変更レベル</span>
                                        <div class="" style="display: flex;align-items: center;">
                                            <i class="lowTextSection" style="left: -26px;right: auto;">低</i>
                                            <input id="myRange" class="slider" type="range" min="1" max="2" step="0.5" [value]="paraphraseTemperature" [(ngModel)]="paraphraseTemperature" [ngModelOptions]={standalone:true} (change)="updateParaphraseTemperature($event)">
                                            <i class="highTextSection" style="right: -26px;left: auto;">高</i>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="toggleDiffOption">
                                        <i>変更箇所を表示</i>
                                        <label class="switch">
                                          <input id="toggleDiffOptionCheckbox" type="checkbox" [(ngModel)]="toggleDiffOptionModel" [ngModelOptions]={standalone:true} [checked]="toggleDiffOptionModel" (change)="onToggleDiffOption()">
                                          <span class="slider round"></span>
                                        </label>
                                    </div>
                                </li>
                                <li>
                                    <div class="feedback" (click)="openFeedbackModal()">
                                        <svg class="feedbackIcons" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.99996 19.0082C9.42496 19.0082 8.88329 18.7165 8.49996 18.2082L7.24996 16.5415C7.22496 16.5082 7.12496 16.4665 7.08329 16.4582H6.66663C3.19163 16.4582 1.04163 15.5165 1.04163 10.8332V6.6665C1.04163 2.98317 2.98329 1.0415 6.66663 1.0415H13.3333C17.0166 1.0415 18.9583 2.98317 18.9583 6.6665V10.8332C18.9583 14.5165 17.0166 16.4582 13.3333 16.4582H12.9166C12.85 16.4582 12.7916 16.4915 12.75 16.5415L11.5 18.2082C11.1166 18.7165 10.575 19.0082 9.99996 19.0082ZM6.66663 2.2915C3.68329 2.2915 2.29163 3.68317 2.29163 6.6665V10.8332C2.29163 14.5998 3.58329 15.2082 6.66663 15.2082H7.08329C7.50829 15.2082 7.99163 15.4498 8.24996 15.7915L9.49996 17.4582C9.79163 17.8415 10.2083 17.8415 10.5 17.4582L11.75 15.7915C12.025 15.4248 12.4583 15.2082 12.9166 15.2082H13.3333C16.3166 15.2082 17.7083 13.8165 17.7083 10.8332V6.6665C17.7083 3.68317 16.3166 2.2915 13.3333 2.2915H6.66663Z" fill="#7A28A0"/>
                                            <path d="M14.1667 7.2915H5.83337C5.49171 7.2915 5.20837 7.00817 5.20837 6.6665C5.20837 6.32484 5.49171 6.0415 5.83337 6.0415H14.1667C14.5084 6.0415 14.7917 6.32484 14.7917 6.6665C14.7917 7.00817 14.5084 7.2915 14.1667 7.2915Z" fill="#7A28A0"/>
                                            <path d="M10.8334 11.4585H5.83337C5.49171 11.4585 5.20837 11.1752 5.20837 10.8335C5.20837 10.4918 5.49171 10.2085 5.83337 10.2085H10.8334C11.175 10.2085 11.4584 10.4918 11.4584 10.8335C11.4584 11.1752 11.175 11.4585 10.8334 11.4585Z" fill="#7A28A0"/>
                                        </svg>
                                        <svg class="feedbackIconsHover" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.1667 1.66669H5.83334C3.53334 1.66669 1.66667 3.52502 1.66667 5.81669V10.8V11.6334C1.66667 13.925 3.53334 15.7834 5.83334 15.7834H7.08334C7.30834 15.7834 7.60834 15.9334 7.75001 16.1167L9.00001 17.775C9.55001 18.5084 10.45 18.5084 11 17.775L12.25 16.1167C12.4083 15.9084 12.6583 15.7834 12.9167 15.7834H14.1667C16.4667 15.7834 18.3333 13.925 18.3333 11.6334V5.81669C18.3333 3.52502 16.4667 1.66669 14.1667 1.66669ZM10.8333 11.4584H5.83334C5.49167 11.4584 5.20834 11.175 5.20834 10.8334C5.20834 10.4917 5.49167 10.2084 5.83334 10.2084H10.8333C11.175 10.2084 11.4583 10.4917 11.4583 10.8334C11.4583 11.175 11.175 11.4584 10.8333 11.4584ZM14.1667 7.29169H5.83334C5.49167 7.29169 5.20834 7.00835 5.20834 6.66669C5.20834 6.32502 5.49167 6.04169 5.83334 6.04169H14.1667C14.5083 6.04169 14.7917 6.32502 14.7917 6.66669C14.7917 7.00835 14.5083 7.29169 14.1667 7.29169Z" fill="#7A28A0"/>
                                        </svg>
                                        <b>フィードバック</b>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="card-body" style="min-height: 360px;">
                        <div class="left-side">
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="position: relative; height: 100%; padding: 24px 40px 0px 24px;">
                                  <span *ngIf="wordCounts.input" class="pp-icon-times" (click)="clearEditors();" style="position: absolute; right: 10px; top: 15px; cursor: pointer;"></span>
                                  <div #inputEditor contenteditable="true" spellcheck="false" id="inputEditor" class="editor" style="height: 100%; outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;" (input)="onInputEditorChange($event)" placeholder="パラフレーズする英文を入力または貼り付け"></div>
                                </div>

                            </div>

                            <div class="card-footer">
                                <div  class="counter">
                                    <span class="count" [ngClass]="wordCounts.input >= 500 ? 'red': ''">{{ wordCounts.input }}/500単語</span>
                                </div>
                                <div class="button-wrap">
                                    <button type="button" (click)="paraphrase()" [disabled]="loader">
                                        <span [style.display]="loader ? 'none' : 'block'">パラフレーズする</span>
                                        <div class="loadingContainer" [style.display]="loader ? 'block' : 'none'">
                                            <div class="ball1"></div>
                                            <div class="ball2"></div>
                                            <div class="ball3"></div>
                                            <div class="ball4"></div>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="right-side"> <!-- blur -->
                            <div class="form-group" style="height: calc(100% - 88px);">

                                <div class="editor-wrapper" style="height: 100%; padding: 24px 40px 0px 24px; position: relative;">
                                  <div #popoverOverlay id="popoverOverlay" style="top: 24px; left: 24px; right: 24px; bottom: 0;">
                                    <div style="position: relative; width: 100%; height: 100%;">
                                      <div #popover id="popover">
                                        <div class="popover-content">
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-like"></span>
                                                <span class="pp-icon-like pp-icon-like-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-dislike"></span>
                                                <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                            </span>
                                          </div>
                                          <div>
                                            <span class="textCopiedSection" (click)="popoverOptionSelected($event, 'copy', currentSelectedSentenceState.alternatives.original_sentence, currentSelectedSentenceState.sentenceTag.textContent)">
                                                <span class="pp-icon-copy"></span>
                                                <span class="pp-icon-copy pp-icon-copy-hover"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div #alternativesPopover id="alternativesPopover">
                                        <div class="alternativesPopover-content">
                                          <div class="heading">
                                            <span>Alternatives</span>
                                            <span class="closePopoverBtn" (click)="closePopover()" style="cursor: pointer;">
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_330_14955)">
                                                    <path d="M17.4082 6.66472C17.7614 6.31148 17.7614 5.73877 17.4082 5.38553C17.0549 5.0323 16.4822 5.0323 16.129 5.38553L11.3414 10.1731L6.55388 5.38553C6.20064 5.0323 5.62793 5.0323 5.27469 5.38553C4.92146 5.73877 4.92146 6.31148 5.27469 6.66472L10.0622 11.4523L5.27469 16.2398C4.92146 16.593 4.92146 17.1658 5.27469 17.519C5.62793 17.8722 6.20064 17.8722 6.55388 17.519L11.3414 12.7315L16.129 17.519C16.4822 17.8722 17.0549 17.8722 17.4082 17.519C17.7614 17.1658 17.7614 16.593 17.4082 16.2398L12.6206 11.4523L17.4082 6.66472Z" fill="#414E62"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_330_14955">
                                                    <rect width="21.7085" height="21.7085" fill="white" transform="translate(0.487305 0.5979)"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                            </span>
                                          </div>
                                          <div class="body">
                                            <ul *ngIf="currentSelectedSentenceState.alternatives">
                                              <ng-container *ngFor="let alternative of currentSelectedSentenceState.alternatives.output_sentence; let i = index;">
                                                <li *ngIf="currentSelectedSentenceState.index != i" (click)="switchToTheAlternative(alternative, i)">
                                                  <sentence [innerHTML]="alternative.suggestion_diff" *ngIf="toggleDiffOptionModel; else nonDiff"></sentence>
                                                  <ng-template #nonDiff>
                                                    <sentence>{{alternative.suggestion}}</sentence>
                                                  </ng-template>
                                                  <span class="likeAndDislikeButtons">
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'like', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-like"></span>
                                                        <span class="pp-icon-like pp-icon-like-hover"></span>
                                                    </span>
                                                    <span class="likeDislikeSection" (click)="popoverOptionSelected($event, 'dislike', currentSelectedSentenceState.alternatives.original_sentence, alternative.suggestion)">
                                                        <span class="pp-icon-dislike"></span>
                                                        <span class="pp-icon-dislike pp-icon-dislike-hover"></span>
                                                    </span>
                                                  </span>
                                                </li>
                                              </ng-container>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div #outputEditor contenteditable="false" spellcheck="false" id="outputEditor" class="editor" style="outline: 0px solid transparent; overflow: hidden; padding-bottom: 30px;"></div>

                                  <div class="limit-exhausted-banner" *ngIf="wordCounts.output > 1 && isLimitExhausted && !loader">
                                    <h3>
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.4645 14.3459L13.248 4.95619C12.5471 3.69282 11.5771 3 10.5094 3C9.44161 3 8.47166 3.69282 7.77069 4.95619L2.55419 14.3459C1.89397 15.5441 1.82062 16.6933 2.35042 17.5981C2.88022 18.5028 3.92352 19 5.29285 19H15.7259C17.0952 19 18.1385 18.5028 18.6683 17.5981C19.1981 16.6933 19.1247 15.5359 18.4645 14.3459ZM9.89805 8.70555C9.89805 8.37137 10.1752 8.09424 10.5094 8.09424C10.8435 8.09424 11.1207 8.37137 11.1207 8.70555V12.7809C11.1207 13.1151 10.8435 13.3923 10.5094 13.3923C10.1752 13.3923 9.89805 13.1151 9.89805 12.7809V8.70555ZM11.0881 15.8049C11.0473 15.8375 11.0066 15.8701 10.9658 15.9027C10.9169 15.9353 10.868 15.9598 10.8191 15.9761C10.7702 16.0005 10.7213 16.0168 10.6642 16.025C10.6153 16.0331 10.5583 16.0413 10.5094 16.0413C10.4605 16.0413 10.4034 16.0331 10.3463 16.025C10.2974 16.0168 10.2485 16.0005 10.1996 15.9761C10.1507 15.9598 10.1018 15.9353 10.0529 15.9027C10.0122 15.8701 9.97141 15.8375 9.93065 15.8049C9.78394 15.65 9.69428 15.4381 9.69428 15.2262C9.69428 15.0143 9.78394 14.8023 9.93065 14.6475C9.97141 14.6149 10.0122 14.5823 10.0529 14.5497C10.1018 14.5171 10.1507 14.4926 10.1996 14.4763C10.2485 14.4519 10.2974 14.4356 10.3463 14.4274C10.4523 14.403 10.5664 14.403 10.6642 14.4274C10.7213 14.4356 10.7702 14.4519 10.8191 14.4763C10.868 14.4926 10.9169 14.5171 10.9658 14.5497C11.0066 14.5823 11.0473 14.6149 11.0881 14.6475C11.2348 14.8023 11.3244 15.0143 11.3244 15.2262C11.3244 15.4381 11.2348 15.65 11.0881 15.8049Z" fill="#FFBD4A"/>
                                        </svg>
                                        Word limit reached
                                    </h3>
                                    <p>You can paraphrase <strong>500 words</strong> at a time. For longer paragraphs, split the paragraph into smaller ones and then paraphrase. </p>
                                  </div>

                                </div>
                            </div>
                            <div class="card-footer">
                                <div  class="counter">
                                    <!-- <span class="count">{{ wordCounts.output }} words</span> -->
                                </div>
                                <div class="copy-text">
                                    <a href="javascript:void(0)" [ngClass]="toggleDiffOptionModel ? 'disableCopyOption': ''" >
                                        <span class="disabledTooltip">変更箇所を非表示にしてコピーする</span>
                                        <span class="copyTooltip">テキストをコピー</span>
                                        <img src="assets/images/copy.svg" alt="コピー" (click)="copyOutputEditorContent()" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <ul class="wordcrumbs">
                    <li>変更前</li>
                    <li>変更後</li>
                </ul>
            </div>
        </div>
    </div>
    <span class="shape-1 d-lg-block d-none"></span>
    <span class="shape-2 d-lg-block d-none"></span>
    <span class="shape-3 d-lg-block d-none"></span>
</section>

<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinkaでは、英文ライティングの精度を上げる各種ツールが充実のラインナップ。無料でご利用いただけます。</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐ試す</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<section class="section-pd">
    <div class="list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h2>Trinkaのパラフレーズツールが選ばれる理由</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2" style="padding: 0;">
                        <p>Trinkaのパラフレーズツールでは、場面や文脈に合った適切な語彙、トーン、スタイルで、英文をより自然な表現に書き換えられます。</p>
                        <p>各文章のパラフレーズ（書き換え・言い換え）を、複数の候補の中から選ぶことができ、変更レベルも調整できるため、ライティングのニーズに合わせたご利用が可能です。</p>
                        <p>Trinkaパラフレーズツールのご利用は無料です。使い方は、変更レベルを選び、ボタンをクリックするだけ。表示される候補の中から最適な文言を選択していけば、言い換えられた文章が仕上ります。</p>
                        <p>Trinkaパラフレーズツールは、迅速で効果的な書き換え・リフレーズを可能にする高性能のツールです。</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/paraphrase.svg" alt="言い換えツール" class="img-fluid" />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div class="list-wrapper-style-2 section-pd pb-0">
        <div class="trinka_container">
            <div class="row justify-content-center align-items-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h2>Trinkaの優れたパラフレーズ機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2 pr-80" style="padding: 0;">
                        <ul class="list-box">
                            <li><b>複数の言い換え候補</b>の中から最適な語句をお選びいただけるため、充実した質の高いパラフレーズが簡単に実現</li>
                            <li><b>ニーズに合わせた変更レベ</b>ルで、シーンに合わせた適切な言い換えが可能</li>
                            <li><b>Trinkaの校正機能で文法ミスのない、</b>洗練された英文に</li>
                            <li><b>ワンクリックの操作で、</b>英文ライティングの作業負荷を低減</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/academic-parapharsing.svg" alt="言い換えツール - ai英文校正"  class="img-fluid" />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>

<div class="cloud_key_features section-pd section-purple list-wrapper-style-2">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinkaのパラフレーズツールを使うメリット</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="assets/images/paraphrasing-icons/Efficiency.png" width="50" height="50" alt="言い換え効率 - 英文校正" style="min-width: 50px;">
                    <h3>作業の効率化</h3>
                    <p>文章のパラフレーズ・言い換えの考案に必要な時間と労力を最小限にすることで、文章の表現ではなく内容の洗練に集中できます。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="assets/images/paraphrasing-icons/Accuracy.png" width="40" height="50" alt="鮮明度の向上 - 文法 チェック" style="max-width: auto;">
                    <h3>明瞭性の向上</h3>
                    <p>元文の意味を保ったまま、誤解のない明瞭な文章に仕上げることができます。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="assets/images/paraphrasing-icons/Vocabulary.png" width="40" height="50" alt="文法エラーを削除する - 英文チ ェッカ" style="max-width: auto;">
                    <h3>文法ミスからの解放</h3>
                    <p>Trinkaの英文校正機能が、パラフレーズと同時に英語のエラー修正も提案します。</p>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">パラフレーズ以上の英文校正も、Trinkaで</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐ試す</a>
                </div>
            </div>
        </div>  
    </div>
</div>

<div class="faqQuestionAnwser section-pd" #target>
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>Trinkaパラフレーズツールに関するよくあるご質問
                    </h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="faqQuestionsList">
            <div class="accordion" id="faq">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCOne">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCOneContent" aria-expanded="true"
                                        aria-controls="QuestionGCOneContent">
                                        Trinkaパラフレーズツールとは何ですか？</a>
                                </div>

                                <div id="QuestionGCOneContent" class="collapse"
                                    aria-labelledby="QuestionGCOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、オンラインで無料で使えるパラフレーズツールです。高度なNLP（自然言語処理）技術を活用し、元の文章の意味を保ちながら英文の書き換え案を提示します。アカウントの作成等は必要なく、どなたでも500単語まで無料でご使用いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwoContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwoContent">Trinkaパラフレーズツールの使い方を教えてください</a>
                                </div>

                                <div id="QuestionGCTwoContent" class="collapse"
                                    aria-labelledby="QuestionGCTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズ・ツールの使い方は以下の通りです。</p>
                                        <ol>
                                            <li>サイトにアクセスします。</li>
                                            <li>サイト内のボックスに文章を入力します。文書ファイルなどからコピーしたテキストのペーストも可能です。</li>
                                            <li>「変更レベル」を選択し、「パラフレーズする」ボタンをクリックすると、処理が始まります。</li>
                                            <li>右側のボックスに、パラフレーズされた文章が生成します。</li>
                                            <li>変更箇所を非表示にした状態で、ボックス右下の「コピー」ボタンをクリックするとパラフレーズされた文章がクリップボードにコピーされます。お好みのアプリケーションなどにペーストしてご利用ください。</li>
                                        </ol>
                                        <p>以上の簡単なステップで、迅速かつ効果的なパラフレーズができます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThreeContent" aria-expanded="true"
                                        aria-controls="QuestionGCThreeContent">Trinkaパラフレーズ・ツールでは、どのように文法ミスの修正が行われますか？</a>
                                </div>

                                <div id="QuestionGCThreeContent" class="collapse"
                                    aria-labelledby="QuestionGCThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、洗練されたアルゴリズムによりテキストを分析し、元の意味を保持したまま、一貫性のある読みやすい別の表現の文章への書き換え、リライトを行います。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFourContent" aria-expanded="true"
                                        aria-controls="QuestionGCFourContent">Trinkaパラフレーズツールはオンラインで利用できますか？</a>
                                </div>

                                <div id="QuestionGCFourContent" class="collapse"
                                    aria-labelledby="QuestionGCFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、Trinkaの言い換え機能をオンラインでどなたにでもお試しいただけるツールです。お試しいただくためのアカウント作成・ログインやツールのインストール等は不要です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFiveContent" aria-expanded="true"
                                        aria-controls="QuestionGCFiveContent">TrinkaパラフレーズツールはQuillBotなどのツールとは何が違うのですか？</a>
                                </div>

                                <div id="QuestionGCFiveContent" class="collapse"
                                    aria-labelledby="QuestionGCFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、リアルタイムのパラフレーズ機能、変更レベルの選択などが備わった包括的なツールです。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixContent">Trinkaパラフレーズツールはどのような人に向けられたツールですか？</a>
                                </div>

                                <div id="QuestionGCSixContent" class="collapse"
                                    aria-labelledby="QuestionGCSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、科学・技術を始めとした様々な学術分野の専門家、コンテンツライター、ブロガー、学生、研究者など、幅広いユーザーに向けて設計されています。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSevenContent">Trinkaパラフレーズ・ツールを利用する際に制限単語数はありますか？</a>
                                </div>

                                <div id="QuestionGCSevenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>現在、Trinkaパラフレーズツールで一度にパラフレーズできるのは500単語までですが、ご利用いただける回数は無制限です。文章を切り分けてお使いいただくことで、テキストのボリュームに関係なくご利用いただけます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEightContent" aria-expanded="true"
                                        aria-controls="QuestionGCEightContent">Trinkaパラフレーズツールは論文など学術的な文章の言い換えを調べるのに向いていますか？</a>
                                </div>

                                <div id="QuestionGCEightContent" class="collapse"
                                    aria-labelledby="QuestionGCEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、学術論文・研究論文の執筆支援のために開発されました。意味を保ちながら、新しい独自の表現に書き換えることで、効果的な引用などが可能になります。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNine">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNineContent" aria-expanded="true"
                                        aria-controls="QuestionGCNineContent">Trinkaパラフレーズツールはブログにも使えますか？</a>
                                </div>

                                <div id="QuestionGCNineContent" class="collapse"
                                    aria-labelledby="QuestionGCNine" data-parent="#faq">
                                    <div class="card-body">
                                        <p>もちろんです。Trinkaパラフレーズツールで文章を書き換えたり異なる表現を探ったりすることで、記事の質は高まるでしょう。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTenContent" aria-expanded="true"
                                        aria-controls="QuestionGCTenContent">Trinkaパラフレーズツールで、パラフレーズに掛かる時間は短縮できますか？</a>
                                </div>

                                <div id="QuestionGCTenContent" class="collapse"
                                    aria-labelledby="QuestionGCTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールでは、代替文をワンクリックで生成し同じ画面に表示。変更後のテキストのダウンロードなどは必要なく、パラフレーズにかかる時間を短縮できます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCeleven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCelevenContent" aria-expanded="true"
                                        aria-controls="QuestionGCelevenContent">Trinkaパラフレーズツールは、ライティング作業の効率アップにどのように役立つのですか？</a>
                                </div>

                                <div id="QuestionGCelevenContent" class="collapse"
                                    aria-labelledby="QuestionGCeleven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、英語の語彙や表現が限られている人や、文章を書き慣れていない人にとっての強い味方です。自分の考えを的確に表現し、効果的に伝えるための言い換え案を素早く見つけることができるため、効率的、スピーディーな執筆に役立ちます。</p>
                                    </div>
                                </div>
                            </div>


                            <div class="card">
                                <div class="card-header" id="QuestionGCTwelve">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCTwelveContent" aria-expanded="true"
                                        aria-controls="QuestionGCTwelveContent">Trinkaパラフレーズツールでは、文章の変更レベル、つまり、どの程度まで書き換えるかを調整できますか？</a>
                                </div>

                                <div id="QuestionGCTwelveContent" class="collapse"
                                    aria-labelledby="QuestionGCTwelve" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinkaパラフレーズツールでは、ご自身のニーズに合わせて変更レベルを調整いただけます。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="faqContainer">
                            <div class="card">
                                <div class="card-header" id="QuestionGCThirteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCThirteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCThirteenContent">Trinkaパラフレーズツールは、どのように文法ミスの修正が行われますか？ </a>
                                </div>

                                <div id="QuestionGCThirteenContent" class="collapse"
                                    aria-labelledby="QuestionGCThirteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズ・ツールでは、内蔵された文法修正エンジンにより自動で文法エラーが修正されます。これにより、間違いのない、洗練されたパラフレーズが可能になります。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFouteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFouteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFouteenContent">Trinkaパラフレーズツールにより、学術論文のオリジナリティを高めることはできますか？ </a>
                                </div>

                                <div id="QuestionGCFouteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFouteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールは、原文の意味を保ちながら、類似率の低いオリジナルな文章への書き換えを可能にします。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCFivteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCFivteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCFivteenContent">Trinkaパラフレーズツールでは、パラフレーズ後の文章の中での言葉の一貫性は保たれますか？</a>
                                </div>

                                <div id="QuestionGCFivteenContent" class="collapse"
                                    aria-labelledby="QuestionGCFivteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinkaパラフレーズツールでは、全体の一貫性を保ちながら、読みやすい文章へのパラフレーズを行います。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSixteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSixteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSixteenContent">Trinkaパラフレーズツールは、意図しない盗用・剽窃を避ける上で役立ちますか？</a>
                                </div>

                                <div id="QuestionGCSixteenContent" class="collapse"
                                    aria-labelledby="QuestionGCSixteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>別の文言・表現への書き換えを高度なアルゴリズムによって行うTrinkaパラフレーズツールをご利用いただくことで、盗用・剽窃と判断されるような文章の類似を避けることができます。これにより、論文をはじめとした文書のオリジナリティが担保され、意図せぬ盗用・剽窃を回避することができます。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCSeventeen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCSeventeenContent" aria-expanded="true"
                                        aria-controls="QuestionGCSeventeenContent">Trinkaパラフレーズツールには、ブラウザの拡張機能やプラグインはありますか？</a>
                                </div>

                                <div id="QuestionGCSeventeenContent" class="collapse"
                                    aria-labelledby="QuestionGCSeventeen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>近日中にブラウザの拡張機能をご利用いただけるようにする予定です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCEighteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCEighteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCEighteenContent">Trinkaパラフレーズツールには、Wordのアドインはありますか？</a>
                                </div>

                                <div id="QuestionGCEighteenContent" class="collapse"
                                    aria-labelledby="QuestionGCEighteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>TrinkaパラフレーズツールのWordアドインを、近日中に公開する予定です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGCNinteen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGCNinteenContent" aria-expanded="true"
                                        aria-controls="QuestionGCNinteenContent">Trinkaパラフレーズツールは他のライティングツールやプラットフォームと統合できますか？</a>
                                </div>

                                <div id="QuestionGCNinteenContent" class="collapse"
                                    aria-labelledby="QuestionGCNinteen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>利便性を高めるため、主要なライティングツールやプラットフォームとの統合オプションを近日中に提供する予定です。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC20">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC20Content" aria-expanded="true"
                                        aria-controls="QuestionGC20Content">Trinkaパラフレーズツールで問題が発生した場合のカスタマーサポートはありますか？</a>
                                </div>

                                <div id="QuestionGC20Content" class="collapse"
                                    aria-labelledby="QuestionGC20" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールでは、ユーザーの皆様の直面する問題について専門のカスタマーサポートチームがサポートいたします。support@trinka.ai までご連絡ください。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC21">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC21Content" aria-expanded="true"
                                        aria-controls="QuestionGC21Content">Trinkaパラフレーズツールはユーザーのデータやコンテンツをどのように扱っていますか？</a>
                                </div>

                                <div id="QuestionGC21Content" class="collapse"
                                    aria-labelledby="QuestionGC21" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinkaパラフレーズツールでは厳重なデータプライバシー対策が施されており、ユーザーデータやコンテンツの安全性が確保されています。</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC22">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC22Content" aria-expanded="true"
                                        aria-controls="QuestionGC22Content">Trinkaパラフレーズツールには、定期的なアップデートや改良が加えられていますか？</a>
                                </div>

                                <div id="QuestionGC22Content" class="collapse"
                                    aria-labelledby="QuestionGC22" data-parent="#faq">
                                    <div class="card-body">
                                        <p>私たちのチームはパフォーマンスとユーザーエクスペリエンスを向上させるためのアップデートや機能強化に継続的に取り組んでいます。Trinkaパラフレーズツールをより効果的でユーザーフレンドリーなものにするために、私たちは常に全力を尽くしています。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionGC23">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse"
                                        data-target="#QuestionGC23Content" aria-expanded="true"
                                        aria-controls="QuestionGC23Content">ユーザーからのフィードバックや提案はツールの改善に役立てられますか？</a>
                                </div>

                                <div id="QuestionGC23Content" class="collapse"
                                    aria-labelledby="QuestionGC23" data-parent="#faq">
                                    <div class="card-body">
                                        <p>はい。Trinkaでは、ユーザーの皆様からのフィードバックやご提案を大切にしています。機能を改善・向上させる上では、実際にお使いいただいた方のご意見が非常に重要だからです。Trinkaパラフレーズツールをより良いものとし、より皆様のお役に立てるものとするために、ぜひ、貴重なご意見をツール右上にある「フィードバック」からお寄せください。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>